import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllDeliveryLocations = createAsyncThunk(
  'deliveryLocation/getAllDeliveryLocations',
  async ({ currentPage = 1, id, limit = 10 }, thunkAPI) => {
    let NEW_URL = `/shuttle?limit=${limit}&page=${currentPage}`;

    if (id) {
      NEW_URL += `&location_id=${id}`;
    }

    try {
      const response = await axiosInstance.get(NEW_URL);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const createDeliveryLocation = createAsyncThunk(
  'deliveryLocation/createDeliveryLocation',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/shuttle`, { ...payload });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteDeliveryLocation = createAsyncThunk(
  'deliveryLocation/deleteDeliveryLocation',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`/shuttle/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const updateDeliveryLocation = createAsyncThunk(
  'deliveryLocation/updateDeliveryLocation',
  async ({ id, payload }, thunkAPI) => {
    try {
      await axiosInstance.put(`/shuttle/${id}`, { ...payload });
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getDeliveryLocationDetail = createAsyncThunk(
  'deliveryLocation/getDeliveryLocationDetail',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/shuttle/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
